/**
 * JavaScript helper
 */

class JsHelper {

    /**
     * Set timeout for promise. Note: Does not stop original promise.
     */
    static wrapPromiseInTimeout(promise, time, errorMessage = 'Promise timeout') {
        let timer = null;

        let timerPromise = new Promise((resolve, reject) => {
            timer = setTimeout(() => reject(errorMessage), time);
        });

        let wrappedPromise = new Promise((resolve, reject) => {
            return promise.then(response => {

                // Stop the timer.
                clearTimeout(timer);

                resolve(response);
            });
        });

        return Promise.race([timerPromise, wrappedPromise]);
    }

    /**
     * Copy object of simple arrays.
     */
    static copyObjectOfArrays(obj) {
        const result = {};

        for (const key of Object.keys(obj)) {
            result[key] = [...obj[key]];
        }

        return result;
    }

    static generateRandomString(length: number): string {
      // https://stackoverflow.com/a/1349426
      let result           = '';
      const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
}

export default JsHelper;
